import { create } from 'zustand';

const STORAGE_KEY = 'supportAgentVisible';

function readStoredVisibility(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) {
      return false;
    }
    return raw === 'true';
  } catch {
    return false;
  }
}

function writeStoredVisibility(visible: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, String(visible));
  } catch {
    // ignore quota / private mode failures
  }
}

interface SupportAgentVisibilityState {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  toggleVisible: () => void;
}

export const useSupportAgentVisibility = create<SupportAgentVisibilityState>(
  (set, get) => ({
    visible: readStoredVisibility(),
    setVisible: (visible) => {
      writeStoredVisibility(visible);
      set({ visible });
    },
    toggleVisible: () => {
      const visible = !get().visible;
      writeStoredVisibility(visible);
      set({ visible });
    },
  })
);
